export const LOGIN_REDIRECT = 'loginRedirect';

export const getLocalStorageValue = (prop: string): boolean | string => {
  const localStorageValue = localStorage.getItem(prop) || '';

  try {
    return JSON.parse(localStorageValue);
  } catch (e) {
    return '';
  }
};

export const setLocalStorageValue = (prop: string, value: boolean | string): void => {
  localStorage.setItem(prop, JSON.stringify(value));
};

export const removeLocalStorageValue = (prop: string): void => {
  localStorage.removeItem(prop);
};
